export default "__VITE_ASSET__ctsEB99X__"